import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

const { Title, Text, Paragraph } = Typography;

interface Step {
  number: string;
  title: string;
  desc: string;
}

const HowItWorks: React.FC = () => {
  const { t } = useTranslation();

  const steps = t('how.steps', { returnObjects: true }) as Step[];

  return (
    <div className={styles.wrapper}>
      <Title level={2} className={styles.heading}>{t('how.heading')}</Title>
      <Title level={4} className={styles.subheading}>
        {t('how.subheading')}
      </Title>

      <div className={styles.timeline}>
        {steps.map((step) => (
          <div key={step.number} className={styles.item}>
            <div className={styles.circle}>{step.number}</div>
            <div className={styles.content}>
              <Text strong className={styles.itemTitle}>
                {step.title}
              </Text>
              <Paragraph className={styles.itemDesc}>{step.desc}</Paragraph>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;
